import React, { useState, useEffect } from "react";

import PageLayout from "../../components/PageLayout";
import Subscription from "./Subscription";
import TransactionHistory from "./TransactionHistory";
import SubscriptionDetails from "./SubscriptionDetails";
import PromoCode from "./PromoCode";
import AssaySubweight from "./AssaySubweight";
import useIsMobile from "../../hooks/useIsMobile";
import HeaderIconSvg from "../../icons/newicons/arrow-down-up.svg";
import SearchIcon from "../../icons/pos_find.png";
import IconAdd from "../../icons/rev_add_group.png";

import "./Payment.css";

const ConfigPayment = () => {
  const isMobile = useIsMobile();
  const [activeTab, setActiveTab] = useState(0);
  const [isCreate, setIsCreate] = useState(false);
  const [filter, setFilter] = useState("");

  return (
    <PageLayout
      icon={HeaderIconSvg}
      heading="Config Lookup"
      hideSearchBar={true}
    >
      <div className="flex flex-middle flex-between">
        <div className="flex flex-middle mt-8 flex-between groups-tabs">
          <div className={`tabs flex`}>
            <div
              className={`ht-60 flex flex-middle pl-16 pr-16 fw-bolder c-pointer bg-lt-gray-2 ${
                activeTab === 0 ? "bg-white c-gray" : "c-white border-gray"
              } fw-bolder'`}
              onClick={() => {
                setActiveTab(0);
              }}
            >
              <span>Subscription</span>
            </div>
            <div
              className={`ht-60 flex flex-middle pl-16 pr-16 fw-bolder c-pointer bg-lt-gray-2 ${
                activeTab === 1 ? "bg-white c-gray" : "c-white border-gray"
              }`}
              onClick={() => {
                setActiveTab(1);
              }}
            >
              <span>Promocode</span>
            </div>
            <div
              className={`ht-60 flex flex-middle pl-16 pr-16 fw-bolder c-pointer bg-lt-gray-2 ${
                activeTab === 2 ? "bg-white c-gray" : "c-white border-gray"
              }`}
              onClick={() => {
                setActiveTab(2);
              }}
            >
              <span>Assay & Subweight</span>
            </div>
          </div>
        </div>
        <div className="flex">
          {activeTab === 1 && (
            <>
              <div className="franchise-filter" style={{ marginRight: 10 }}>
                <div className=" p-relative ">
                  <input
                    value={filter}
                    className=" form-control top_form_input forminput fs-16  ht-35 search pl-32"
                    placeholder="Search"
                    style={{ paddingLeft: 35, height: 40 }}
                    onChange={(e) => {
                      setFilter(e.target.value);
                    }}
                  />
                  <img src={SearchIcon} className="wt-20 t-8 p-absolute l-8" />
                </div>
              </div>
            </>
          )}

          {activeTab !== 2 && (
            <div
              className="btn ht-40 flex flex-middle flex-between bg-gray pl-8 pr-8 pb-8 pt-8 mb-8 c-white fw-bolder c-pointer"
              onClick={() => {
                setIsCreate(true);
              }}
            >
              <span>Create {activeTab === 0 ? "Subscription" : "Promocode"}</span>
            </div>
          )}

          {activeTab === 2 && (
            <div
              className="btn ht-40 flex flex-middle flex-between bg-gray pl-8 pr-8 pb-8 pt-8 mb-8 c-white fw-bolder c-pointer"
              onClick={() => {
                setIsCreate(true);
              }}
            >
              <span>Add Assay</span>
            </div>
          )}
        </div>
      </div>
      <div>
        {activeTab === 0 ? (
          <SubscriptionDetails isCreate={isCreate} setIsCreate={setIsCreate} />
        ) : activeTab === 1 ? (
          <PromoCode
            isCreate={isCreate}
            setIsCreate={setIsCreate}
            filter={filter}
          />
        ) : (
          <AssaySubweight isCreate={isCreate} setIsCreate={setIsCreate} />
        )}
      </div>
    </PageLayout>
  );
};

export default ConfigPayment;
